export default "__VITE_ASSET__$e1E$CiE__"